import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../../../Global/Modals/DialogForm';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ProgressButton from '../../../Global/Buttons/Progress';
import classnames from 'classnames';
import ButtonStyles from '../../../../styles/button';
import SpacingStyles from '../../../../styles/helpers/spacing';
import combineStyles from '../../../../utils/combineStyles';
import TypographyStyles from '../../../../styles/typography';
const styles = theme => ({
  container: { paddingLeft: theme.spacing.unit * 3 }
});
export class DeleteShipmentModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };
  state = { isSubmitting: false };
  _handleCancel = () => {
    const { onClose } = this.props;
    onClose();
  };
  _handleSave = async () => {
    const { onSave } = this.props;
    this.setState({ isSubmitting: true });
    await onSave();
    this.setState({ isSubmitting: false });
  };
  render() {
    const { open, onClose, t, classes } = this.props;
    const { isSubmitting } = this.state;
    return (
      <DialogForm
        open={open}
        title={t('Are you sure you want to delete this shipment?')}
        onClose={onClose}
        onSave={this._handleSave}
        footer={
          <Fragment>
            <div className={classes.spacer} />
            <Button
              className={classes.button}
              onClick={this._handleCancel}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Cancel')}
            </Button>
            <ProgressButton
              color="primary"
              className={classnames(classes.button)}
              classes={{
                label: classnames(classes.buttonLabel)
              }}
              onClick={this._handleSave}
              isSubmitting={isSubmitting}
            >
              {t('Delete')}
            </ProgressButton>
          </Fragment>
        }
      >
        <Grid container spacing={16}>
          <Grid
            item
            lg={12}
            classes={{
              item: classnames(classes.container)
            }}
          >
            <div className={classes.body1}>
              {t('This action cannot be undone.')}
            </div>
          </Grid>
        </Grid>
      </DialogForm>
    );
  }
}
const translatedDeleteShipmentModal = withNamespaces()(DeleteShipmentModal);
export default withStyles(
  combineStyles(styles, SpacingStyles, ButtonStyles, TypographyStyles)
)(translatedDeleteShipmentModal);
